import { useState } from 'react';
import { getServiceInUsesService, getServiceRegisterInUsesService, getServicesService } from 'services/service';

const useService = () => {
  const [services, setServices] = useState([]);
  const [serviceInUses, setServiceInUses] = useState([]);
  const [serviceRegisterInUses, setServiceRegisterInUses] = useState([]);
  const [loading, setLoading] = useState(false);

  const getServices = async ({ idBuilding, filter }) => {
    setLoading(true);
    const response = await getServicesService({ idBuilding, filter });
    if (response.data) {
      setServices(response?.data?.filter((service) => service.unitGroupId) ?? []);
    }
    setLoading(false);
    return response;
  };

  const getServiceInUses = async ({ idBuilding, filter }) => {
    setLoading(true);
    const response = await getServiceInUsesService({ idBuilding, filter });
    if (response.data) {
      setServiceInUses(response.data.sort((prevService, curService) => prevService.name.localeCompare(curService.name)));
    }
    setLoading(false);
    return response;
  };

  const getServiceRegisterInUses = async ({ idBuilding, filter }) => {
    setLoading(true);
    const response = await getServiceRegisterInUsesService({ idBuilding, filter });
    if (response.data) {
      setServiceRegisterInUses(response.data);
    }
    setLoading(false);
    return response;
  };

  return {
    getServices,
    getServiceInUses,
    getServiceRegisterInUses,
    services,
    serviceInUses,
    serviceRegisterInUses,
    loading,
  };
};

export default useService;
